import { __ } from '@wordpress/i18n';

const ticketDefaultFields = [
  {
    type: "text",
    label: __( "Subject", "hive-support" ),
    errormsg: __( "Please provide the subject.", "hive-support" ),
    metakey: "hs_ticket_title",
    class: "",
    inboxid: [],
    fieldrequire: true,
  },
  {
    type: "textarea",
    label: __( "Message", "hive-support" ),
    errormsg: __( "Please share your problem in details.", "hive-support" ),
    metakey: "hs_ticket_message",
    class: "",
    inboxid: [],
    fieldrequire: true,
  },
  {
    type: "dropdown",
    label: __( "Select Priority", "hive-support" ),
    errormsg: "",
    metakey: "hs_ticket_priority",
    class: "",
    inboxid: [],
    options: [
      {
        value: "Normal",
        optionmeta: "b7745b03-efd0-4203-8a2d-25aa2c6d1191",
      },
      {
        value: "High",
        optionmeta: "e7c82888-4fdf-409f-a451-cbe7b455ddd0",
      },
      {
        value: "Urgent",
        optionmeta: "d4e5f161-c678-4997-ae98-897db2f98914",
      },
      {
        value: "Low",
        optionmeta: "f72b5036-7d9b-4f08-ac94-6e8c51a195b3",
      },
      {
        value: "Medium",
        optionmeta: "b1572f31-3c70-4b52-b3dd-78022335894d",
      },
      {
        value: "Critical",
        optionmeta: "b1572f31-7c70-4b40-b3dd-857477854774",
      },
    ],
    fieldrequire: false,
  },
  {
    type: "media",
    label: "",
    errormsg: "",
    metakey: "hs_ticket_media",
    class: "",
    inboxid: [],
    fieldrequire: false,
  },
];

export default ticketDefaultFields;
